import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Constants } from '../../core/config/Constants'
import { ExtraService } from '../../core/services/extra.service';
import { Invites } from '../../core/models/invites';
import { AttendeesService } from '../../core/services/attendees.service';

@Component({
  selector: 'app-attendees',
  templateUrl: './attendees.component.html',
  styleUrls: ['./attendees.component.css'],
  providers:[AttendeesService]
})
export class AttendeesComponent implements OnInit {
  disableButton:boolean = true;
  eventId:string = '';
  isError:boolean = false;
  message:string='';
  errorMessage: Array<String> = new Array();
  emailClass = 'form-control';
  emailList: Array<any> = new Array();
  emailCheckList: Array<string> = new Array();
  invites = new Invites();

  totalInvites:number=0;
  attending:number=0;
  notAttending:number=0;
  mayBe:number=0;
  notReplied:number=0;
  
  constructor(private attendeesService:AttendeesService,
    private extraService:ExtraService,private route: ActivatedRoute,private router:Router) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
      this.extraService.changeSideBar(true);
      this.route.params.subscribe(params => {
      let id = params['eventId'];
        if(id) {
          console.log(id);
          this.eventId = id;
          this.setAttendees(id); 
          this.extraService.setCurrentEventId(id);                                                                  
        } 
      });
  }

  setAttendees(id:string){
    this.attendeesService.getAttendeesList(id).subscribe(event=>{
      this.totalInvites = 0;
      this.attending = 0;
      this.notAttending=0;
      this.mayBe=0;
      this.notReplied = 0;
      this.emailList = new Array();
      if( event ) {
        let attending;
        for(let key in event) {
          this.emailCheckList.push(key.replace(/\,/g,'.'));
          if(event[key].isAttending == '0') {
            this.attending++;
            attending = Constants.ATTENDING;
            this.emailList.push({email:key.replace(/\,/g,'.'),attending:attending});
          } else if(event[key].isAttending == '1') {
            this.notAttending++;
            attending = Constants.NOT_ATTENDING;
            this.emailList.push({email:key.replace(/\,/g,'.'),attending:attending});
          } else if(event[key].isAttending == '2') {
            this.mayBe++;
            attending = Constants.MAYBE;
            this.emailList.push({email:key.replace(/\,/g,'.'),attending:attending});
          } else if(event[key].isAttending == '-1') {
            this.notReplied++;
            attending = Constants.NOT_RESPONDED;
            this.emailList.push({email:key.replace(/\,/g,'.'),attending:attending});
          }
          this.totalInvites++;
        }
        this.totalInvites = this.totalInvites;
        this.attending = Math.floor((this.attending*100)/this.totalInvites);
        this.notAttending = Math.floor((this.notAttending*100)/this.totalInvites);
        this.mayBe = Math.floor((this.mayBe*100)/this.totalInvites);
        this.notReplied = Math.floor((this.notReplied*100)/this.totalInvites);
      }
    });
  }

  submit() {
    if(this.emailValidate()) {
      this.disableButton = false;
      let invites = this.invites;
      this.attendeesService.addInvites(this.eventId, invites).then(res=>{
        this.message = "Added Successfully";
        this.invites.email = null;
        setTimeout(function() {
          this.disableButton = true;
          this.message = null;
          this.setAttendees(this.eventId);
          //window.location.reload(true);
        }.bind(this), 2000);
      }).catch(error=>{
        this.message = error.message;
      });
    } else {
       this.isError = true;
    }
  }

  emailValidate(){
    let valid = true;
    this.isError = false;
    this.clearClasses();
    this.message = null;
    this.errorMessage = new Array();

    let emailRex = "[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}";
      if(this.invites.email == null || this.invites.email.trim().length <1){
        this.isError = true;
        valid = false;
        this.errorMessage.push("Email cannot be empty");
        this.emailClass = "form-control fieldWithErrors";
      } else if(this.invites.email != null && !this.invites.email.match(emailRex)) {
        this.isError = true;
        valid = false;
        this.errorMessage.push('Email is not Valid');
        this.emailClass = 'form-control fieldWithErrors';
      } else {
          if(this.invites.email.match(emailRex)) {
            let index = this.emailCheckList.indexOf(this.invites.email);
            if(index == -1) {
              this.isError = false;
              valid = true;
              this.emailClass = 'form-control';
            } else {
              this.isError = true;
              valid = false;
              this.errorMessage.push('Email already exists.');
              this.emailClass = 'form-control fieldWithErrors';
            }
          } 
      }
      return valid;

  }

  clearClasses(){
    this.emailClass = 'form-control';
  }



}



// WEBPACK FOOTER //
// /app/src/app/event/attendees/attendees.component.ts